import service from "@/store/services/packages-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  package: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, pack) => {
    state.package = pack;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((pack) => {
      commit("SET_RESOURCE", pack);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((pack) => {
      commit("SET_RESOURCE", pack);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((pack) => {
      commit("SET_RESOURCE", pack);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  package: (state) => state.package,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((pack) => ({
      id: pack.id,
      name: pack.name,
    }));
  },
};

const packs = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default packs;
